export const REM_NUM_CONVERSION = 10;
export const PX_NUM_CONVERSION = 16;
const NUMBER_ONLY_REGEX = /[^0-9.]/g;

export const getNumValFromStr = (str: string) => +(str.replace(NUMBER_ONLY_REGEX, ''));

export const convertNonPxStrToPxBasedNum = (str: string): number => {
  if (str.includes('px')) {
    return getNumValFromStr(str);
  } else if (str.includes('rem')) {
    return getNumValFromStr(str) * REM_NUM_CONVERSION;
  } else { // em
    return getNumValFromStr(str) * PX_NUM_CONVERSION;
  }
};
